"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const facility_dto_1 = require("../../../../dtos/facility-dto");
require("../../../../../organisation/dtos/tag-dto");
const BehaviorSubject_1 = require("rxjs/internal/BehaviorSubject");
require("../../../../../common/components/dnaR-paginator/dnaR-paginator.component");
const facility_service_1 = require("../../../../services/facility.service");
const dnaRSnackBar_service_1 = require("../../../../../common/dna-r/dnaRSnackBar.service");
const i0 = require("@angular/core");
const i1 = require("../../../../services/facility.service");
const i2 = require("../../../../../common/dna-r/dnaRSnackBar.service");
const i3 = require("@angular/material/tooltip");
const i4 = require("@angular/common");
const i5 = require("../../../../../common/components/dnaR-paginator/dnaR-paginator.component");
function LeadTagsViewTabComponent_tbody_26_tr_1_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", tag_r2.name, " ");
} }
function LeadTagsViewTabComponent_tbody_26_tr_1_td_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, " Resident Manager ");
    i0.ɵɵelementEnd();
} }
function LeadTagsViewTabComponent_tbody_26_tr_1_td_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 23);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", tag_r2.userFirstName.charAt(0).toUpperCase(), "", tag_r2.userLastName.charAt(0).toUpperCase(), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", tag_r2.userFirstName, " ", tag_r2.userLastName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(8, 5, tag_r2.modifiedDate, "dd-MMM-yyyy"), " ");
} }
function LeadTagsViewTabComponent_tbody_26_tr_1_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, LeadTagsViewTabComponent_tbody_26_tr_1_td_2_div_1_Template, 2, 0, "div", 16);
    i0.ɵɵtemplate(2, LeadTagsViewTabComponent_tbody_26_tr_1_td_2_div_2_Template, 9, 8, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !tag_r2.isCustom);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", tag_r2.isCustom);
} }
function LeadTagsViewTabComponent_tbody_26_tr_1_td_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵelement(2, "input", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", tag_r2.isHidden);
} }
function LeadTagsViewTabComponent_tbody_26_tr_1_td_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, LeadTagsViewTabComponent_tbody_26_tr_1_td_3_div_1_Template, 3, 1, "div", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", tag_r2.isCustom);
} }
function LeadTagsViewTabComponent_tbody_26_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, LeadTagsViewTabComponent_tbody_26_tr_1_td_1_Template, 3, 1, "td", 16);
    i0.ɵɵtemplate(2, LeadTagsViewTabComponent_tbody_26_tr_1_td_2_Template, 3, 2, "td", 16);
    i0.ɵɵtemplate(3, LeadTagsViewTabComponent_tbody_26_tr_1_td_3_Template, 2, 1, "td", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !tag_r2.isDeleted);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !tag_r2.isDeleted);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !tag_r2.isDeleted);
} }
function LeadTagsViewTabComponent_tbody_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, LeadTagsViewTabComponent_tbody_26_tr_1_Template, 4, 3, "tr", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.tags);
} }
/**
 * Displays the facility details view tab.
 */
class LeadTagsViewTabComponent {
    /**
     * Initializes a new instance of the @see FacilityDetailsViewTabComponent class.
     */
    constructor(facilityService, snackBarService) {
        this.facilityService = facilityService;
        this.snackBarService = snackBarService;
        /**
         * Event emitted when the user chooses to edit the tags page.
         */
        this.onEdit = new core_1.EventEmitter();
        /**
         * The tags to display in the filter drop down.
         */
        this.tags$ = new BehaviorSubject_1.BehaviorSubject(null);
        /**
         * The card pagination page index.
         */
        this.pageIndex = 0;
        /**
         * The card pagination page size.
         */
        this.pageSize = 25;
        /**
         * The card pagination page size options
         */
        this.pageSizeOptions = [25, 50, 75, 100, 'All'];
        /**
         * The total number of tags
         */
        this.totalNumberOfTags = 0;
        /**
         * If true then the filter drawer is open are shown, otherwise filter drawer is close and hidden.
         */
        this.filterDrawerOpen = false;
    }
    set tags(value) {
        this._tags = value;
    }
    get tags() {
        return this._tags;
    }
    set facility(value) {
        this._facility = value;
    }
    get facility() {
        return this._facility;
    }
    ngOnChanges() {
        this.loadTags();
    }
    loadTags() {
        let skip = null;
        let take = null;
        // Calculate pagination values only if isn't a number (ie 'All')
        if (!isNaN(this.pageSize)) {
            skip = this.pageSize * this.pageIndex;
            take = Number(this.pageSize);
        }
        this.facilityService.getAllTagsForFacilityId(this.facility.id, skip, take).then((result) => {
            this.totalNumberOfTags = result.totalCount;
            this.tags$.next(result.result);
            this.tags = this.tags$.value;
        }, () => {
            this.snackBarService.failure("Unexpected error while loading tags");
        });
    }
    /**
     * Emits the @see onEdit event.
     */
    edit() {
        var _a;
        (_a = this.onEdit) === null || _a === void 0 ? void 0 : _a.emit(this.tags);
    }
    /**
     * Handing the page event
     *
     * @param e The page event parameters.
     */
    handlePageEvent(e) {
        this.totalNumberOfTags = e.length;
        this.pageSize = e.pageSize;
        this.pageIndex = e.pageIndex;
        this.loadTags();
    }
    /**
     * Opens the filter drawer.
     */
    openFilterDrawer() {
        this.filterDrawerOpen = true;
    }
    /**
     * Closes the filter drawer.
     */
    closeFilterDrawer() {
        this.filterDrawerOpen = false;
    }
}
exports.LeadTagsViewTabComponent = LeadTagsViewTabComponent;
LeadTagsViewTabComponent.ɵfac = function LeadTagsViewTabComponent_Factory(t) { return new (t || LeadTagsViewTabComponent)(i0.ɵɵdirectiveInject(i1.FacilityService), i0.ɵɵdirectiveInject(i2.DnaRSnackBarService)); };
LeadTagsViewTabComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LeadTagsViewTabComponent, selectors: [["lead-tags-view-tab"]], inputs: { tags: "tags", facility: "facility" }, outputs: { onEdit: "onEdit" }, features: [i0.ɵɵNgOnChangesFeature], decls: 29, vars: 7, consts: [[1, "lead-tags-tab", "vertical-tab"], [1, "panel-body"], [1, "form-section", "form-tag"], [1, "row", "space-below-label"], [1, "col-xs-5"], [1, "sub-header", "page-header"], [1, "pull-right"], ["data-automation", "edit-button", 1, "btn", "btn-primary", "btn-inline-block-md", 3, "click"], [1, "col-xs-12", "tags-table"], [1, "dna-r"], [1, "table"], [1, "list-header"], [1, "tag-column"], [1, "required"], [1, "updated-column"], ["matTooltip", "Remove tag option from pre-admission list", 1, "dna-info-icon", 3, "matTooltipPosition"], [4, "ngIf"], [1, "paginator"], [3, "length", "pageSize", "pageSizeOptions", "pageIndex", "itemsDisplayLabel", "page"], [4, "ngFor", "ngForOf"], ["class", "user-info", 4, "ngIf"], [1, "user-info"], [1, "user-initials"], [1, "user-name-and-date"], ["class", "column hide-column", 4, "ngIf"], [1, "column", "hide-column"], ["name", "hide", "type", "checkbox", "disabled", "", 1, "hide-tag", 3, "checked"]], template: function LeadTagsViewTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "h2", 5);
        i0.ɵɵtext(6, "Lead tags");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "button", 7);
        i0.ɵɵlistener("click", function LeadTagsViewTabComponent_Template_button_click_8_listener() { return ctx.edit(); });
        i0.ɵɵtext(9, "Edit");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 3);
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "div", 9);
        i0.ɵɵelementStart(13, "table", 10);
        i0.ɵɵelementStart(14, "thead", 11);
        i0.ɵɵelementStart(15, "tr");
        i0.ɵɵelementStart(16, "th", 12);
        i0.ɵɵelementStart(17, "span");
        i0.ɵɵelementStart(18, "span", 13);
        i0.ɵɵtext(19, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(20, " Tag");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "th", 14);
        i0.ɵɵtext(22, " Updated ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "th");
        i0.ɵɵtext(24, " Hide ");
        i0.ɵɵelement(25, "span", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(26, LeadTagsViewTabComponent_tbody_26_Template, 2, 1, "tbody", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 17);
        i0.ɵɵelementStart(28, "dnaR-paginator", 18);
        i0.ɵɵlistener("page", function LeadTagsViewTabComponent_Template_dnaR_paginator_page_28_listener($event) { return ctx.handlePageEvent($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(25);
        i0.ɵɵproperty("matTooltipPosition", "after");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.tags && ctx.tags.length > 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("length", ctx.totalNumberOfTags)("pageSize", ctx.pageSize)("pageSizeOptions", ctx.pageSizeOptions)("pageIndex", ctx.pageIndex)("itemsDisplayLabel", "Rows");
    } }, directives: [i3.MatTooltip, i4.NgIf, i5.DnaRPaginator, i4.NgForOf], pipes: [i4.DatePipe], styles: [".mat-tooltip {\n  font-weight: 400;\n  font-size: 14px;\n  color: #000000 !important;\n  line-height: 14px;\n  height: 26px;\n  background: #ffffff;\n  border: 1px solid #595959;\n  border-radius: 4px;\n  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.14));\n  padding-bottom: 0px !important;\n  font-family: 'Source Sans Pro' !important;\n  max-width: unset !important;\n}\n.page-header[_ngcontent-%COMP%] {\n  margin-top: 0px;\n}\n.no-left-padding[_ngcontent-%COMP%] {\n  padding-left: 0px;\n}\n.user-info[_ngcontent-%COMP%] {\n  display: flex;\n}\n.user-info[_ngcontent-%COMP%]   .user-initials[_ngcontent-%COMP%] {\n  display: block;\n  font-size: 16px;\n  font-weight: 600;\n  height: 32px;\n  width: 32px;\n  background-color: #D2D2D2;\n  color: #000000;\n  text-align: center;\n  line-height: 24px;\n  margin-top: 8px;\n  margin-right: 8px;\n  padding-top: 4px;\n  float: left;\n}\n.user-info[_ngcontent-%COMP%]   .user-name-and-date[_ngcontent-%COMP%] {\n  text-overflow: ellipsis;\n  display: block;\n  float: right;\n  width: auto;\n}\n.column[_ngcontent-%COMP%] {\n  display: inline-block;\n  float: left;\n  margin: 0 16px;\n}\n.column.hide-column[_ngcontent-%COMP%] {\n  width: 90px;\n  margin: 0px;\n  vertical-align: middle;\n  padding: 12px 0px 0px 16px !important;\n}\n.hide-tag[_ngcontent-%COMP%] {\n  width: 18px;\n  height: 18px;\n  background-color: #AAAAAA;\n}\n.tags-table[_ngcontent-%COMP%] {\n  background-color: #ffffff;\n  padding: 0px 13px;\n}\n.row-tags[_ngcontent-%COMP%] {\n  margin-right: -13px;\n  margin-left: -13px;\n}\n.form-tag[_ngcontent-%COMP%] {\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n}\n.tag-column[_ngcontent-%COMP%] {\n  width: 277px;\n}\n.updated-column[_ngcontent-%COMP%] {\n  width: 264px;\n}\n.list-header[_ngcontent-%COMP%] {\n  border-bottom: 1px solid #D2D2D2;\n  font-weight: bold;\n  height: 56px !important;\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: 0;\n  color: #595959;\n  line-height: 56px;\n  vertical-align: middle;\n}\n.paginator[_ngcontent-%COMP%] {\n  margin: 0 12px;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LeadTagsViewTabComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'lead-tags-view-tab',
                styleUrls: ['./lead-tags-view-tab.component.less'],
                templateUrl: './lead-tags-view-tab.component.html'
            }]
    }], function () { return [{ type: i1.FacilityService }, { type: i2.DnaRSnackBarService }]; }, { tags: [{
            type: core_1.Input
        }], facility: [{
            type: core_1.Input
        }], onEdit: [{
            type: core_1.Output
        }] }); })();
